export const TOOL_INSTRUCTIONS = {
    placemark: {
        initial: 'Click to place a marker',
        active: 'Click to place a marker'
    },
    measure: {
        initial: 'Click to set start point',
        active: 'Click to set end point'
    },
    path: {
        initial: 'Click to add points. Double-click to finish.',
        active: 'Click to add points. Double-click to finish.'
    },
    polygon: {
        initial: 'Click to add vertices. Double-click to close.',
        active: 'Click to add vertices. Double-click to close.'
    },
    contour: {
        initial: 'Select a contour interval below, then click a contour line to highlight it',
        active: 'Click a contour line to highlight it. Double-click to unhighlight.'
    },
    stream: {
        initial: 'Click a stream to highlight it',
        active: 'Click streams to build selection. Double-click to unhighlight.'
    },
    label: {
        initial: 'Click to place a label, then type',
        active: 'Click to place a label, then type. Double-click an existing label to edit.'
    },
    comment: {
        initial: 'Click anywhere on the map to drop a comment pin',
        active: 'Click anywhere on the map to drop a comment pin. Click an existing pin to open its thread.'
    },
    sketch: {
        initial: 'Drag on the map to draw',
        active: 'Drag to draw. Pick a colour and size below.'
    }
};
export const TOOL_LABELS = {
    placemark: 'Placemark',
    measure: 'Measure',
    path: 'Path',
    polygon: 'Polygon',
    contour: 'Contour',
    stream: 'Stream',
    label: 'Label',
    comment: 'Comment',
    sketch: 'Sketch'
};
export const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;
export const getToolInstruction = (tool) => {
    switch (tool) {
        case 'placemark':
            return 'Click to place a marker.';
        case 'measure':
            return 'Click to set start point.';
        case 'path':
            // Inline helper text in ToolDrawPanel handles path-specific instructions; no banner needed.
            return '';
        case 'polygon':
            // Inline helper text in ToolDrawPanel handles polygon-specific instructions; no banner needed.
            return '';
        case 'contour':
            return 'Select a contour interval below, then click a contour line to highlight it.';
        case 'stream':
            return 'Click a stream to highlight it.';
        case 'label':
            return 'Click to place a label, then type.';
        case 'comment':
            return 'Click anywhere on the map to drop a comment pin.';
        case 'sketch':
            // Drag draws, so the usual drag-to-pan is unavailable while sketching.
            // Point users at the navigation that still works: arrow keys (or two
            // fingers on a touch device) to move, scroll/pinch to zoom.
            return 'Drag to draw. Arrow keys or two fingers move the map; scroll or pinch to zoom.';
        default:
            return '';
    }
};
